import styled, { css } from 'styled-components';
import { getColor } from 'utils';
import constants from 'constants/index';
const light = constants.THEME.LIGHT;

const { HEADER_HEIGHT, FOOTER_HEIGHT } = constants;

const offset = HEADER_HEIGHT + FOOTER_HEIGHT;

export const Welcome = styled('div')`
  width: 100%;
  height: 100%;
  margin: 0 auto;
  color: ${props => getColor(props, 'onPrimary')};
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: local;
  overflow: auto;

  ${() => css`max-height: calc(100dvh - ${offset / 16}rem);`}
`;

export const MainSection = styled('div')`
  width: 100%;
  max-width: 1128px;
  height: 100%;
  margin: 0 auto;
`;

export const HorizontalStack  = styled('div')`
  display: flex;
  align-items: flex-start;
`;

export const ButtonsSection  = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Section = styled('div')`
  width: ${props => props.w || 'auto'};
  height: ${props => props.h || 'auto'};
  transform: translateY(${p => p.offsetY || '0px'});
`;

export const ImageView = styled('div')`
  position: relative;
  width: ${props => props.w || '50px'};
  height: ${props => props.h || '50px'};
  flex-shrink: 0;
  background-image: ${props => `url(${props.image})`};
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  filter: invert(${props => (props.$selectedTheme === light) ? 0 : 1});
`;

export const PreviewContainer = styled('div')`
  position: relative;
  width: 25rem;
  height: 25rem;
  top: -100px;
`;

export const LogoContainer = styled('div')`
  display: flex;
  justify-content: left;
  align-items: left;
  gap: ${props => props.space || '40px'};
  width: 100%;
  height: ${props => props.h || 'auto'};
  margin: 0 auto;
`;

export const MiddleHeaderTitle = styled('div')`
  text-align: center;
  justify-content: center;
  font-family: "Poppins-Bold";
  color: ${props => getColor(props, 'secondary')};
  font-size: 24px;
  font-style: normal;
  font-weight: bold;
  height: 27px;
`;

export const MiddleTitle = styled('div')`
  font-family: "Poppins-Bold";
  flex-shrink: 0;
  color: ${props => getColor(props, 'onPrimary')};
  font-size: 32px;
  font-style: normal;
  font-weight: 800;
  line-height: 31px; /* 96.875% */
  text-align: center;
  justify-content: center;
`;

export const BottomTitle = styled('div')`
  color: ${props => getColor(props, 'secondary')};
  font-family: "Poppins-Bold";
  font-size: 28px;
  font-style: normal;
  font-weight: 800;
  min-width: 800px;
  line-height: 31px; /* 55.357% */

  @media (max-width: 1024px) {
    min-width: 0;
    font-size: clamp(1rem, 2.5vw, 1.75rem);
    line-height: 1.3;
  }
`;

export const GetStartedTitle = styled('div')`
  font-family: "Poppins-Bold";
  font-size: 5rem;
  font-style: normal;
  font-weight: 800;
  line-height: 100px;
  min-width: 600px;
  color: ${props => getColor(props, 'secondary')};

  @media (max-width: 1024px) {
    min-width: 0;
    font-size: clamp(2rem, 6vw, 4rem);
    line-height: 1.2;
  }
`;

export const PrimeButton = styled('div')`
  font-family: "Poppins-Medium";
  display: flex;
  width: 200px;
  height: 48px;
  padding: 11px 40px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 30px;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  background-color: #983995;
  cursor: pointer;
  color: ${props => getColor(props, 'white')};
  &:hover {
    filter: brightness(1.15);
    background-color: #5D225B;
  }
  margin: 0 auto;
`;

export const SubscribeButton = styled('div')`
  font-family: "Poppins-Medium";
  display: flex;
  width: 200px;
  height: 48px;
  padding: 11px 40px;
  justify-content: center;
  align-items: center;
  gap: 10px;

  font-size: 16px;
  font-weight: 500;
  cursor: pointer;

  border: 1px solid #bdbdbd;  /* Fix border syntax */
  border-radius: 30px;  /* Rounded corners */
  background-color: transparent; /* Clear background */
  color: #983995;

  &:hover {
    filter: brightness(1.15);
    background-color: #bdbdbd;
    border: 1px solid #983995;
  }
`;

export const DotsContainer = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  gap: 8px;
`;

export const Dot = styled.button`
  width: 12px;
  height: 12px;
  padding: 0;
  border-radius: 50%;
  border: 1px solid ${props => (props.active ? '#333' : '#888')}; /* Dark border for active, lighter for inactive */
  background-color: ${props => (props.color)};
  transition: all 0.2s ease-in-out;

  &:hover {
    filter: brightness(1.5);
    border-color: ${props => getColor(props, 'onPrimary')};; /* Matching border color on hover */
  }
`;



// ─── Free Assets Section ─────────────────────────────────────────────────────
export const FreeAssetsSection = styled('div')`
  width: 100%;
  max-width: 1128px;
  margin: 0 auto 120px;
  text-align: left;
`;

export const FreeAssetsSubtitle = styled('div')`
  font-family: "Poppins-Regular";
  font-size: 1rem;
  margin-bottom: 32px;
  width: 450px;
  max-width: 100%;
  color: ${props => getColor(props, 'secondary')};
`;

export const FreeAssetsContainer = styled('div')`
  display: flex;
  gap: 31px;

  @media (max-width: 900px) {
    flex-wrap: wrap;
  }
`;

export const CategoryList = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 9px;
  width: 260px;
`;

export const CategoryItem = styled('button')`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 16px;
  background-color: ${props => (props.active ? getColor(props, 'bgListItem') : 'transparent')};
  border: 1px solid #ddd;
  border-radius: 4px;
  font-family: "Poppins-Regular";
  font-size: 16px;
  cursor: pointer;
  height: 80px;
  color: ${props => getColor(props, 'onPrimary')};

  &:hover {
    outline: ${props => '0.0625rem solid ' + getColor(props, 'accent')};
  }

  & > div { /* icon wrapper */
    flex-shrink: 0;
  }
`;

export const AssetGrid = styled('div')`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px 30px;     /* row-gap:15px, column-gap:30px */

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;
